export default __webpack_public_path__ + "static/media/weekly_form_locked.81167fcf.png";